import { useCallback, useEffect, useRef, useState } from "react";
import { ESIGN_IFRAME } from "utils/constants";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import Loader from "../Components/Loader";

const UNIVERSIGN_EMBED_URL =
  process.env.REACT_APP_YOUSIGN_SANDBOX === ESIGN_IFRAME.SANDBOX_ENV_VALUE
    ? "https://apps.alpha.universign.com/npds/embed.js"
    : "https://apps.universign.com/npds/embed.js";

const View = ({ onNext, onBack, signatureLink }) => {
  const [isReady, setIsReady] = useState(false);
  const scriptRef = useRef(null);

  const initializeUniversign = useCallback(() => {
    const container = document.getElementById("iframe-container");
    if (container) {
      container.innerHTML = "";
    }

    if (scriptRef.current && document.body.contains(scriptRef.current)) {
      if (window.initIframe) {
        window.initIframe("iframe-container", signatureLink);
      }
      return;
    }

    const script = document.createElement("script");
    script.src = UNIVERSIGN_EMBED_URL;
    script.onload = () => {
      if (window.initIframe) {
        window.initIframe("iframe-container", signatureLink);
      }
    };
    scriptRef.current = script;
    document.body.appendChild(script);
  }, [signatureLink]);

  useEffect(() => {
    if (!signatureLink) return;

    const handleNpdsEvent = (event) => {
      const { eventType } = event.detail || {};
      if (
        eventType === "action.closed" ||
        eventType === "transaction.lifecycle.completed"
      ) {
        onNext({});
      }
    };

    window.addEventListener("npdsEvent", handleNpdsEvent);

    const initTimer = setTimeout(() => {
      setIsReady(true);
      initializeUniversign();
    }, ESIGN_IFRAME.LOAD_DELAY_MS);

    return () => {
      clearTimeout(initTimer);
      window.removeEventListener("npdsEvent", handleNpdsEvent);
      const container = document.getElementById("iframe-container");
      if (container) {
        container.innerHTML = "";
      }
    };
  }, [signatureLink, initializeUniversign, onNext]);

  if (!isReady) {
    return <Loader />;
  }

  return (
    <Layout>
      <Header
        title="Signez votre contrat <b>en ligne</b>"
        highlight="Signez"
        subtitle="Signature électronique"
      />

      <div className="mutualMobility__body">
        <div
          id="iframe-container"
          style={{ width: "100%", height: "600px" }}
        ></div>
      </div>
    </Layout>
  );
};

export default View;
